import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "comment_wrap" }
const _hoisted_2 = { class: "comment_form" }
const _hoisted_3 = { class: "comment_list" }
const _hoisted_4 = { class: "custom_scroll" }
const _hoisted_5 = { class: "comment_list_info" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "comment_btn" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = {
  key: 1,
  class: "no_list"
}

import { apiService, onMounted, reactive, types, watch, ModalDefault, getMessageByCode, ref, CommonUtils } from "@/BaseComponent";

    interface Props {
        idx?: number;
        type?: 1 | 2;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'commentForAction',
  props: {
    idx: {},
    type: {}
  },
  setup(__props: any) {

    const props = __props;
    const commentRef = ref<HTMLTextAreaElement | null>(null);
    const state = reactive({
        isEditMode: false as boolean,
        editIdx: 0 as number,
        removeIdx: 0 as number,
        list: [] as any[],
        comment: "" as string,
        page: 0 as number,
        size: 10 as number,
    });

    const modal = reactive({
        isShowModal: false,
        tab: -1 as number,
        isResult: false as boolean,
        title: "alert" as string,
        content: "" as string,
    });

    const checkValue = (comment: string) => {
        let msg = "";

        if (comment === "" || comment === null || comment === undefined) msg = "댓글을 입력해주세요.";
        else if (comment.length > 200) msg = "댓글은 최대 200자 까지 입력이 가능합니다.";

        if (msg) {
            modal.tab = -1;
            modal.title = "예외 발생";
            modal.content = msg;
            modal.isShowModal = true;
            return false;
        } else {
            return true;
        }
    };

    const initComment = () => {
        state.isEditMode = false;
        state.comment = "";
        state.editIdx = 0;
        state.removeIdx = 0;
    };

    onMounted(() => {
        if (props.idx) getList();
    });

    watch(
        () => props.idx,
        () => {
            if (props.idx) {
                getList();
            }
        },
    );
    const getList = async () => {
        const param: types.ReqReportCommentList = {
            page: state.page,
            size: state.size,
            searchType: null,
            searchText: null,
        };

        const res = await apiService.boardActionComment.list(props.idx!!, param);

        if (res.returnCode === 0) {
            state.list = res.list.data;
        } else if (res.returnCode === 11) {
        } else {
            console.error(res.description);
        }
    };

    const add = async () => {
        if (checkValue(state.comment)) {
            const param: types.ReqBoardActionCommentForAdmin = {
                content: state.comment,
            };
            const res = await apiService.boardActionComment.add(props.idx!!, param);
            if (res.returnCode === 0) {
                modal.tab = 8;
                modal.title = "알림";
                modal.content = "저장이 완료되었습니다.";
                modal.isShowModal = true;
                getList();
                initComment();
            } else if (res.returnCode === 11) {
            } else {
                modal.tab = 8;
                modal.title = "예외 발생";
                modal.content = getMessageByCode(res.returnCode);
                modal.isShowModal = true;
            }
        }
    };

    const edit = (item: any) => {
        state.isEditMode = true;
        state.editIdx = item.idx;
        item.isEditMode = true;
    };

    const editApi = async (comment: string) => {
        if (checkValue(comment)) {
            const param: types.ReqBoardActionCommentForAdmin = {
                content: comment,
            };

            const res = await apiService.boardActionComment.modify(state.editIdx, param);
            if (res.returnCode === 0) {
                modal.tab = 8;
                modal.title = "알림";
                modal.content = "저장이 완료되었습니다.";
                modal.isShowModal = true;
                getList();
                initComment();
            } else if (res.returnCode === 11) {
            } else {
                modal.tab = 8;
                modal.title = "예외 발생";
                modal.content = getMessageByCode(res.returnCode);
                modal.isShowModal = true;
            }
        }
    };

    const remove = async (idx: number) => {
        state.removeIdx = idx;
        modal.tab = 5;
        modal.title = "알림";
        modal.content = "댓글을 삭제하시겠습니까?";
        modal.isShowModal = true;
    };

    const removeForComfirm = async (idx: number) => {
        const res = await apiService.boardActionComment.remove(idx);
        if (res.returnCode === 0) {
            modal.tab = 8;
            modal.title = "알림";
            modal.content = "삭제가 완료되었습니다.";
            modal.isShowModal = true;

            getList();
        } else if (res.returnCode === 11) {
        } else if (res.returnCode === 19) {
            modal.tab = 8;
            modal.title = "삭제 실패";
            modal.content = "비밀번호를 잘못 입력하셨네요.";
            modal.isShowModal = true;
        } else if (res.returnCode === 22) {
            modal.tab = 8;
            modal.title = "알림";
            modal.content = "비밀번호가 일치하지 않습니다.";
            modal.isShowModal = true;
        } else {
            modal.tab = 8;
            modal.title = "예외 발생";
            modal.content = getMessageByCode(res.returnCode);
            modal.isShowModal = true;
        }
    };

    const closeModal2 = () => {
        modal.isShowModal = false;
        modal.tab = -1;
    };

    const callBackModal = async (param: any) => {
        if (param.action === "confirm") {
            switch (modal.tab) {
                case 5:
                    removeForComfirm(state.removeIdx);
                    break;
            }
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "wrap_title" }, "댓글 목록", -1)),
        _createElementVNode("form", null, [
          _withDirectives(_createElementVNode("textarea", {
            class: "custom_scroll",
            ref_key: "commentRef",
            ref: commentRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).comment) = $event)),
            placeholder: "댓글을 입력해주세요"
          }, null, 512), [
            [_vModelText, _unref(state).comment]
          ]),
          _createElementVNode("div", { class: "comment_btn" }, [
            _createElementVNode("button", {
              class: "_blue",
              onClick: add
            }, "등록")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_unref(state).list != null && _unref(state).list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(state).list, (comment) => {
                return (_openBlock(), _createElementBlock("li", {
                  style: {"gap":"0 !important"},
                  key: comment.idx
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "name" }, "다시함께상담센터", -1)),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(CommonUtils).dateFormat(new Date(comment.createDate), ".", true)), 1),
                    _createElementVNode("div", _hoisted_7, [
                      (!comment.isEditMode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                              class: "_blue",
                              onClick: ($event: any) => (edit(comment))
                            }, "수정", 8, _hoisted_8),
                            _createElementVNode("button", {
                              class: "_gray",
                              onClick: ($event: any) => (remove(comment.idx))
                            }, "삭제", 8, _hoisted_9)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("button", {
                              class: "_blue",
                              onClick: ($event: any) => (editApi(comment.content))
                            }, "저장", 8, _hoisted_10),
                            _createElementVNode("button", {
                              class: "_gray",
                              onClick: ($event: any) => (comment.isEditMode = false)
                            }, "취소", 8, _hoisted_11)
                          ], 64))
                    ])
                  ]),
                  (!comment.isEditMode)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "comment_con",
                        innerHTML: comment.content
                      }, null, 8, _hoisted_12))
                    : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                        key: 1,
                        class: "text_over",
                        "onUpdate:modelValue": ($event: any) => ((comment.content) = $event)
                      }, null, 8, _hoisted_13)), [
                        [_vModelText, comment.content]
                      ])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_14, "등록된 댓글이 없습니다."))
        ])
      ])
    ]),
    (_unref(modal).isShowModal)
      ? (_openBlock(), _createBlock(_unref(ModalDefault), {
          key: 0,
          type: _unref(modal).tab,
          title: _unref(modal).title,
          content: _unref(modal).content,
          onClose: closeModal2,
          onCallback: callBackModal
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})